import { useEffect } from "react";
import {
	LoginWrapper,
	LeftSection,
	RightSection,
	LoginSection,
} from "./styled";
import { Heading } from "../../../../../components/Heading";
import { verifyEmail } from "actions/authActions";
import rightImg from "./../../../../../icons/login-right-img.jpg";
import { Button } from "../../../../../components/Button";
import { navigate } from "@reach/router";
import Skeleton from "react-loading-skeleton";
import { LogoWrapper } from "../../../../../components/LogoWrapper/LogoWrapper";
import { useCurrentUser } from "hooks/auth";

const EmailVerification = ({ path: _path, ...props }) => {
	const queryParams = new URLSearchParams(window.location.search);
	const token = queryParams.get("sc");
	const email = queryParams.get("email");

	const { currentUser } = useCurrentUser();

	if (email == null || token == null) navigate("/login", { replace: true });
	else if (currentUser && currentUser.email_verified) {
		if (currentUser.company_id)
			navigate(`/account/${currentUser.company_id}/company-profile/edit-user-profile`);
		else navigate("/search");
	}

	useEffect(() => {
		verifyEmail(email, token);
	}, [email, token]);

	return (
		<LoginWrapper>
			<LeftSection>
				<LogoWrapper />

				<LoginSection>
					<Heading marginBottom="50px">
						<span className="welcome">Email Verification.</span>
						<span>Verifying your email...</span>
					</Heading>
					<Skeleton
						count={5}
						duration={0.5}
					/>
					{currentUser && currentUser.email_verified ? (
						<Button onClick={() => navigate("/login")}>Return to login</Button>
					) : null}
				</LoginSection>
			</LeftSection>
			<RightSection
				style={{ backgroundImage: `url(${rightImg})` }}
			></RightSection>
		</LoginWrapper>
	);
};

export default EmailVerification;